/**
 * @file
 * Restores jQuery helpers removed in jQuery 4 for legacy vendor scripts.
 *
 * SelectWoo 1.0.x and other vendored libraries still call $.isArray,
 * $.isFunction, $.trim, $.isPlainObject, and $.inArray.
 */
/* eslint-disable max-len, require-jsdoc */

((($) => {
  'use strict';

  if (typeof $.isArray !== 'function') {
    $.isArray = Array.isArray;
  }

  if (typeof $.isFunction !== 'function') {
    $.isFunction = function (obj) {
      return typeof obj === 'function';
    };
  }

  if (typeof $.trim !== 'function') {
    $.trim = function (str) {
      return str == null ? '' : String(str).trim();
    };
  }

  if (typeof $.isPlainObject !== 'function') {
    $.isPlainObject = function (obj) {
      if (
        !obj ||
        typeof obj !== 'object' ||
        Object.prototype.toString.call(obj) !== '[object Object]'
      ) {
        return false;
      }

      const proto = Object.getPrototypeOf(obj);
      return proto === null || proto === Object.prototype;
    };
  }

  if (typeof $.inArray !== 'function') {
    $.inArray = function (elem, arr, i) {
      return arr == null ? -1 : Array.prototype.indexOf.call(arr, elem, i ?? 0);
    };
  }
})(jQuery));
